/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Warehouse_SelectorInputs */

const en_audit_warehouse_selector = /** @type {(inputs: Audit_Warehouse_SelectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse Selector`)
};

const es_audit_warehouse_selector = /** @type {(inputs: Audit_Warehouse_SelectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selector de Almacen`)
};

/**
* | output |
* | --- |
* | "Warehouse Selector" |
*
* @param {Audit_Warehouse_SelectorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_warehouse_selector = /** @type {((inputs?: Audit_Warehouse_SelectorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Warehouse_SelectorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_warehouse_selector(inputs)
	return es_audit_warehouse_selector(inputs)
});